import CustomProductLoanActionTypes from './custom-product-loan-proposal.types';

/** ***************** ADD PRODUCT LOAN PROPOSAL START ***************** */
export const addCustomProductLoanProposalStart = (getData: any) => ({
	type: CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_START,
	payload: getData,
});

export const addCustomProductLoanProposalSuccess = (successData: any) => ({
	type: CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const addCustomProductLoanProposalFailure = (failureData: any) => ({
	type: CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const addCustomProductLoanProposalResponseReset = () => ({
	type: CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const addCustomProductLoanProposalListResponseChanged = () => ({
	type: CustomProductLoanActionTypes.ADD_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** ADD PRODUCT LOAN PROPOSAL END ***************** */

/** ***************** UPDATE PRODUCT LOAN PROPOSAL START ***************** */
export const updateCustomProductLoanProposalStart = (getData: any) => ({
	type: CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_START,
	payload: getData,
});

export const updateCustomProductLoanProposalSuccess = (successData: any) => ({
	type: CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_SUCCESS,
	payload: successData,
});

export const updateCustomProductLoanProposalFailure = (failureData: any) => ({
	type: CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_FAILURE,
	payload: failureData,
});

export const updateCustomProductLoanProposalResponseReset = () => ({
	type: CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_RESET,
});

export const updateCustomProductLoanProposalListResponseChanged = () => ({
	type: CustomProductLoanActionTypes.UPDATE_CUSTOM_PRODUCT_LOAN_PROPOSAL_RESPONSE_CHANGED,
});

/** ***************** UPDATE PRODUCT LOAN PROPOSAL END ***************** */

/** ***************** FETCH CUSTOM PRODUCT LOAN DETAILS START *********************** */
export const fetchCustomProductDetailsStart = (fetchData: any) => ({
	type: CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_START,
	payload: fetchData,
});

export const fetchCustomProductDetailsSuccess = (successData: any) => ({
	type: CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchCustomProductDetailsFailure = (failureData: any) => ({
	type: CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchCustomProductDetailsResponseResetStart = () => ({
	type: CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_RESPONSE_RESET,
});

export const fetchCustomProductDetailsResponseChanged = () => ({
	type: CustomProductLoanActionTypes.FETCH_CUSTOM_PRODUCT_LOAN_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH CUSTOM PRODUCT LOAN DETAILS END *********************** */
